module.exports = __webpack_public_path__ + "img/4.e8d6f9a6.png";